import { render, staticRenderFns } from "./MobileNav.vue?vue&type=template&id=3285bbdb&scoped=true&"
import script from "./MobileNav.vue?vue&type=script&lang=ts&"
export * from "./MobileNav.vue?vue&type=script&lang=ts&"
import style0 from "./MobileNav.vue?vue&type=style&index=0&id=3285bbdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3285bbdb",
  null
  
)

export default component.exports